import { render, staticRenderFns } from "./InspectionTemplate.vue?vue&type=template&id=1ed59c4e&"
import script from "./InspectionTemplate.vue?vue&type=script&lang=js&"
export * from "./InspectionTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports